// extracted by mini-css-extract-plugin
export default {"headerAction":"styles_headerAction__U6cml"};